import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import dog from '../images/dog_ate_404.png'
class NoMatch extends Component {
  render() {
    return (
      <div style={styles.container}>
        <div
          style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '5vh' }}
        >
          <img width={320} src={dog} alt="" />
        </div>
        <h2>Dog ate this page!</h2>
        <Link to="/">Go Home</Link>
      </div>
    )
  }
}
export default withRouter(NoMatch)

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    flexDirection: 'column',
  },
}
